import {RouteConfig} from 'vue-router';
import CoursePrintView from '@/views/media/course/index.vue';
import CertificatePrintView from '@/views/media/certificate/index.vue';
import MediaIframeView from '@/views/media/iframe/index.vue';

export const MediaRoutes: Array<RouteConfig | any> = [
  {path: '/media/certificate/print', name: 'certificate-print', component: CertificatePrintView},
  {path: '/media/course/print', name: 'course-print', component: CoursePrintView},
  {path: '/media/cike/mp', name: 'course-print', component: MediaIframeView}
];
